(() => {
  const isTouch = matchMedia("(pointer: coarse)").matches;
  if (!isTouch) return;

  document.querySelectorAll(".inkd-brands-lines .ibl__grid").forEach((grid) => {
    let armed = null;

    grid.addEventListener("click", (e) => {
      const a = e.target.closest("a.ibl__link");
      if (!a) return;

      const tip = a.querySelector(".ibl__tooltip");
      if (!tip) return;

      if (armed !== a) {
        e.preventDefault();
        armed?.classList.remove("is-armed");
        a.classList.add("is-armed");
        armed = a;
      }
    }, { passive: false });

    document.addEventListener("click", (e) => {
      if (!grid.contains(e.target)) {
        armed?.classList.remove("is-armed");
        armed = null;
      }
    }, { passive: true });
  });
})();
